import { supabase } from '@/lib/supabase';

type AdminOnboardingRow = {
  completed_at: string | null;
};

const TABLE_NAME = 'admin_onboarding_states';

export async function hasCompletedAdminOnboarding(profileId: string) {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('completed_at')
    .eq('profile_id', profileId)
    .maybeSingle<AdminOnboardingRow>();

  if (error) {
    console.warn('Failed to load admin onboarding state.', error.message);
    return false;
  }

  return Boolean(data?.completed_at);
}
